import React, { useState } from 'react';
import { ChevronDown, HelpCircle, Send } from 'lucide-react';
import { FAQS, TELEGRAM_URL } from '../data/mock';
import CaliLetters from '../components/CaliLetters';

const FAQ = () => {
  const [open, setOpen] = useState(0);

  return (
    <div className="pt-[74px]">
      <section className="relative border-b border-white/10">
        <div className="absolute inset-0 smoke-red opacity-50" />
        <div className="relative max-w-7xl mx-auto px-4 lg:px-8 py-14 text-center">
          <HelpCircle className="mx-auto text-[#a6e22e] mb-3" size={34} />
          <h1 className="font-anton text-4xl lg:text-6xl uppercase">
            <CaliLetters text="FAQ" />
          </h1>
          <p className="text-white/60 mt-3">Najczęściej zadawane pytania.</p>
        </div>
      </section>

      <section className="max-w-3xl mx-auto px-4 lg:px-8 py-12">
        <div className="space-y-3">
          {FAQS.map((f, i) => (
            <div key={i} className="cb-panel rounded-2xl border border-white/10 overflow-hidden">
              <button onClick={() => setOpen(open === i ? -1 : i)} className="w-full flex items-center justify-between gap-4 px-5 py-4 text-left">
                <span className="font-semibold">{f.q}</span>
                <ChevronDown size={20} className={`text-[#a6e22e] shrink-0 transition-transform ${open === i ? 'rotate-180' : ''}`} />
              </button>
              <div className={`grid transition-all duration-300 ${open === i ? 'grid-rows-[1fr]' : 'grid-rows-[0fr]'}`}>
                <div className="overflow-hidden">
                  <p className="px-5 pb-4 text-white/65 text-sm">{f.a}</p>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="cb-panel rounded-2xl border border-white/10 p-6 mt-8 text-center smoke-red">
          <p className="font-anton uppercase text-lg mb-2">
            <CaliLetters text="Nie znalazłeś odpowiedzi?" />
          </p>
          <p className="text-white/60 text-sm mb-4">Napisz do nas bezpośrednio na Telegramie — pomożemy wybrać produkt.</p>
          <a href={TELEGRAM_URL} target="_blank" rel="noreferrer" className="btn-green inline-flex items-center gap-2 px-6 py-3"><Send size={16} /> Zapytaj na Telegramie</a>
        </div>
      </section>
    </div>
  );
};

export default FAQ;
